/* eslint-disable */

/** unique or primary key constraints on table "argo.log_level" */
export enum ArgoLogLevelConstraint {
  /** unique or primary key constraint on columns "level" */
  LogLevelPkey = 'log_level_pkey'
}

export enum ArgoLogLevelEnum {
  /** Debug */
  Debug = 'debug',
  /** Error */
  Error = 'error',
  /** Info */
  Info = 'info',
  /** Warning */
  Warning = 'warning'
}

/** select columns of table "argo.log_level" */
export enum ArgoLogLevelSelectColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Level = 'level'
}

/** update columns of table "argo.log_level" */
export enum ArgoLogLevelUpdateColumn {
  /** column name */
  Description = 'description',
  /** column name */
  Level = 'level'
}

